import { useEditor } from '@smartfire/js-block-engine';
import clsx from 'clsx';
import React from 'react';
import { GuedelonButton } from '../../bouton-guedelon/button';
import style from './card.module.scss';
function Card({
    image,
    imageMobile,
    className,
    tags,
    title,
    resume,
    link,
    linkText = "Lire l'article",
    htmlText = false,
}: {
    image: string;
    imageMobile: string;
    className: string;
    tags: { name }[];
    title: string;
    resume: string;
    link: string;
    linkText?: string;
    htmlText?: boolean;
}) {
    const { isEditing } = useEditor();

    return (
        <div className={clsx(style.block, className)}>
            <a href={isEditing ? undefined : link}>
                <div className={style.image}>
                    <img src={(imageMobile && imageMobile !== '' ? imageMobile : image) || undefined} alt={title} />
                </div>
                <div className={style.tags}>
                    {tags &&
                        tags.map((tag, index) => (
                            <div key={index} className={style.tag}>
                                {tag.name}
                            </div>
                        ))}
                </div>
                {htmlText ? (
                    <h4 className={style.title} dangerouslySetInnerHTML={{ __html: title }} />
                ) : (
                    <h4 className={style.title}>{title}</h4>
                )}
                {htmlText ? (
                    <div className={style.resume} dangerouslySetInnerHTML={{ __html: resume }} />
                ) : (
                    <div className={style.resume}>{resume}</div>
                )}
            </a>
            <GuedelonButton className={style.link} href={isEditing ? undefined : link}>
                {linkText}
            </GuedelonButton>
        </div>
    );
}

export default Card;
